import api from '../utils/api'
import { API_ROOT } from '../constants'

export const getPaddleBillingSubscriptionDetails = (transactionId) => {
  return api.post(`${API_ROOT}/v3/subscription/paddle-billing/get-subscription`, {
    transactionId
  })
}

export const getOrCreatePaddleCustomer = (email) => {
  return api.post(`${API_ROOT}/v3/subscription/paddle-billing/customer`, { email })
}
